import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('AppButton').create(({ theme }) => ({
  root: {
    alignItems: 'center',
    backgroundColor: theme.colors.button.primary.background,
    color: theme.colors.text.primary,
    borderRadius: '12px',
    fontFamily: 'inter',
    textTransform: 'none',
    '&[data-variant="secondary"]': {
      backgroundColor: theme.colors.button.secondary.background,
      color: theme.colors.text.secondary,
    },
    '&[data-variant="storiesReward"]': {
      backgroundColor: '#414246',
      gap: '6px',
      height: theme.sizes.button.height,
      img: {
        width: '55px',
        pointerEvents: 'none',
      },

      '&:disabled': {
        backgroundColor: '#28292d',
      },
    },
    '&[data-variant="storiesRewardPrimary"]': {
      backgroundColor: theme.colors.button.primary.background,
      gap: '6px',
      height: theme.sizes.button.height,
      img: {
        width: '55px',
        pointerEvents: 'none',
      },

      '&:disabled': {
        backgroundColor: '#28292d',
      },
    },
    '&[data-isloadinggolnden="true"]': {
      backgroundColor: '#F3CA1490!important',
    },
    '&[data-variant="special"]': {
      backgroundColor: theme.colors.text.primary,
      color: 'black',
    },
    '&:disabled': {
      backgroundColor: theme.colors.button.primary.disabled,
      color: theme.colors.text.secondary,
    },
    '&:disabled:hover': {
      backgroundColor: theme.colors.button.primary.background,
    },
    '&[data-fullwidth="true"]': {
      width: '100%',
    },

    '&[data-variant="golden"]': {
      backgroundColor: '#F3CA14',
      color: 'black',
    },

    '&[data-variant="transparent"]': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },

    '&[data-canclaim="false"]': {
      backgroundColor: 'rgba(255, 255, 255, 0.16)',
      color: theme.colors.text.primary,
    },

    '&[data-isfaded="true"]': {
      opacity: 0.2,
    },

    button: {
      height: '100%',
    },
  },
  progress: {
    fill: 'black!important',
    backgroundColor: 'black',
  },
}))
